import { render } from "./Loader.vue?vue&type=template&id=bc8b3f78&scoped=true"
import script from "./Loader.vue?vue&type=script&lang=js"
export * from "./Loader.vue?vue&type=script&lang=js"

import "./Loader.vue?vue&type=style&index=0&id=bc8b3f78&lang=scss&scoped=true"

import exportComponent from "/Users/skynet/Documents/Sites Safe/Safe_Sites_Modifs/SAFE_MED/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bc8b3f78"]])

export default __exports__